import { render, staticRenderFns } from "./CardMobileGold.vue?vue&type=template&id=4f3e6189&scoped=true&"
import script from "./CardMobileGold.vue?vue&type=script&lang=js&"
export * from "./CardMobileGold.vue?vue&type=script&lang=js&"
import style0 from "./CardMobileGold.vue?vue&type=style&index=0&id=4f3e6189&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e6189",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3e6189')) {
      api.createRecord('4f3e6189', component.options)
    } else {
      api.reload('4f3e6189', component.options)
    }
    module.hot.accept("./CardMobileGold.vue?vue&type=template&id=4f3e6189&scoped=true&", function () {
      api.rerender('4f3e6189', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/mobile/CardMobileGold.vue"
export default component.exports